import { Button } from '@willow/shared-web';

import { Layout } from '../layout/Layout';

import './LoanLoadError.scss';

interface Props {
  onRetry: () => void;
  onChooseAnotherLoan?: () => void;
}

export const LoanLoadError = ({ onRetry, onChooseAnotherLoan }: Props) => (
  <Layout bannerMessages={[]}>
    <section className="loan-load-error">
      <h1>We couldn&apos;t load your loan</h1>
      <h2>Please try again in a moment</h2>
      <div className="loan-load-error__actions">
        <Button onClick={onRetry}>Try again</Button>
        {onChooseAnotherLoan && (
          <Button variant="secondary" onClick={onChooseAnotherLoan}>
            Choose a different loan
          </Button>
        )}
      </div>
    </section>
  </Layout>
);
